import actions from './actions';
import reducer from './reducer';

const rxChange = {
    actions,
    reducer,
    name: 'rxChange',
};

export default rxChange; 